import * as React from 'react';

import {StartDataSyncSidePanel} from 'src/components/agency-onboard/side-panels/start-data-sync';
import {TenDLCRegistrationSidePanel} from 'src/components/agency-onboard/side-panels/tendlc-registration';
import {ConfigureDefaultBranding} from 'src/components/agency-onboard/side-panels/configure-default-branding';
import {FallbackEmailandPhone} from 'src/components/agency-onboard/side-panels/fallback-email-and-phone';
import {DNSConfiguration} from 'src/components/agency-onboard/side-panels/dns-configuration';
import {NoteWriteback} from 'src/components/agency-onboard/side-panels/note-writeback';
import {AddPhoneNumber} from 'src/components/agency-onboard/side-panels/add-phone-number';

import {useLoadingApi} from 'src/hooks/useApi';
import {Loading} from 'src/components/lib/loading';
import type {sidePanelProps} from 'src/components/agency-onboard/types/side-panel';

import maincss from 'src/components/agency-onboard/agency-onboard.css';


const SIDE_PANEL_COMPONENT = {
  'Start Data Sync': StartDataSyncSidePanel,
  '10DLC Registration': TenDLCRegistrationSidePanel,
  'Configure Default Branding': ConfigureDefaultBranding,
  'Note Writeback Configuration': NoteWriteback,
  'DNS Configuration': DNSConfiguration,
  'Add Phone Numbers': AddPhoneNumber,
  'Add Fallback Email and Phone Number': FallbackEmailandPhone,
} as const;

export const SidePanelLoader = (props: sidePanelProps) => {
  const {task, onTaskSubmit, onTaskCancel, taskName} = props;
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'Start Data Sync': (props: StartDataSyncProps) => Element; readonly '10DLC Registration': (props: TenDLCFormProps) => Element; ... 4 more ...; readonly 'Add Fallback Email and Phone Number': (props: FallbackProps) => Element; }'.
  const SelectedTask = SIDE_PANEL_COMPONENT[taskName];

  const {response: formData, loaded: dataLoaded} = useLoadingApi(
    () => `onboard/task/${task['id']}`,
    [],
  );

  if (!formData || !dataLoaded) {
    return (
      <div className={maincss.loaderDiv}>
        <Loading />
      </div>
    );
  }

  return (
    <SelectedTask
      task={task}
      taskName={taskName}
      onTaskSubmit={onTaskSubmit}
      onTaskCancel={onTaskCancel}
      data={formData}
    />
  );
};
